import React from 'react';

const NoEventsAvailable = ({ message, status }) => {
  // Default messages based on status
  const defaultMessages = {
    no_events: "No events are currently available for booking.",
    past_events: "All scheduled events have already taken place.",
    default: "Bookings are unavailable at this time.",
  };

  // Use custom message or fall back to default based on status
  const displayMessage = message || defaultMessages[status] || defaultMessages.default;

  return (
    <div className="no-events-container">
      <div className="no-events-icon">
        <i className="icon-attention"></i>
      </div>
      <h2 className="no-events-title">Bookings Unavailable</h2>
      <p className="no-events-message">{displayMessage}</p>
      <p className="no-events-check-back">Please check back soon for upcoming events.</p>
    </div>
  );
};

export default NoEventsAvailable; 